import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/company/:companyId/reports/',
    name: 'reports',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "widgets" */ './views/reports.vue')
      ),
    meta: {
      authRequired: true,
    },
  },
]
